class FacetsToggle extends HTMLElement {
  constructor() {
    super();
    this.drawer = document.getElementById('Facet-Drawer');
  }
  connectedCallback() {
    this.addEventListener('click', () => {
      document.body.classList.toggle('open-cc');
      this.drawer.classList.toggle('active');
      this.drawer.removeAttribute('inert');
    });
  }
}
customElements.define('facet-toggle', FacetsToggle);

class SidebarToggle extends HTMLElement {
  constructor() {
    super();
    this.drawer = document.getElementById('Sidebar-Container');
  }
  connectedCallback() {
    const span = this.querySelector('span');
    const hideFilters = span.textContent;

    this.addEventListener('click', (e) => {
      e.preventDefault();
      this.drawer.classList.toggle('facets--sidebar-open');

      span.textContent = this.drawer.classList.contains('facets--sidebar-open') ? hideFilters : theme.strings.showFilters;
    });
  }
}
customElements.define('sidebar-toggle', SidebarToggle);

class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    this.addEventListener('click', (e) => {
      if (e.target.classList.contains('thb-filter-content--button')) {
        this.onMore(e);
      }
    });
    
    this.querySelector('form').addEventListener('input', this.debouncedOnSubmit.bind(this));
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const container = document.querySelectorAll('.thb-filter-count, .mobile-filter-count');
    document.getElementById('ProductGridContainer')?.querySelector('.products')?.classList.add('loading');

    for (var item of container) {
      item.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = element => element.url === url;

      if (FacetFiltersForm.filterData.some(filterDataUrl)) {
        FacetFiltersForm.renderSectionFromCache(filterDataUrl, event);
      } else {
        FacetFiltersForm.renderSectionFromFetch(url, event);
      }
    });
    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);

  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, {
          html,
          url
        }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);

      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);

  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser().parseFromString(html, 'text/html')?.getElementById('ProductGridContainer')?.innerHTML;

    let top = document.getElementById('ProductGridContainer')?.getBoundingClientRect().top + document.documentElement.scrollTop - parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'), 10) - 30;

    if(window.gsap && window.ScrollTrigger) {
      ScrollTrigger.batch('.animations-true .products .product-card--image-primary', {
        start: "top 90%",
        onEnter: (elements) => {
          gsap.to(elements, { scale: 1, opacity: 1, stagger: 0.15, ease: window.theme.settings.animation_easing });
        }
      });
    }

    document.getElementById('ProductGridContainer')?.querySelectorAll('.lazyload')?.forEach((image) => {
      lazySizes.loader.unveil(image);
    });

    window.scrollTo({
      top: top,
      left: 0,
      behavior: "smooth"
    });
  }

  static renderProductCount(html) {
    const countHtml = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount');
    const container = document.querySelectorAll('.desktop-filter-count, .search-filter-count');

    if (countHtml) {
      container.forEach(item => {
        item.innerHTML = countHtml.innerHTML;
        item.classList.remove('loading');
      });
    }

  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements =
      parsedHTML.querySelectorAll('#FacetFiltersForm collapsible-row, #FacetFiltersFormMobile collapsible-row');
    
    const newLabels = Array.from(facetDetailsElements).map(element => element.dataset.label);
    
    const currentFilters = document.querySelectorAll('collapsible-row[data-label]');
    
    currentFilters.forEach((filter) => {
      if (!newLabels.includes(filter.dataset.label)) {
        filter.remove();
      }
    });
    
    const matchesLabel = (element) => {
      const jsFilter = event ? event.target.closest('collapsible-row') : undefined;
      return jsFilter ? element.dataset.label === jsFilter.dataset.label : false;
    };
    const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesLabel(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesLabel);
    facetsToRender.forEach((element) => {
      const targetElement = document.querySelector(`collapsible-row[data-label="${element.dataset.label}"]`);
      if (targetElement) {
        targetElement.innerHTML = element.innerHTML;
      }
    });
    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);
    FacetFiltersForm.syncSortSelects(parsedHTML);
    FacetFiltersForm.renderQuickFilters(parsedHTML, event);


    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('collapsible-row'));
  }

  static renderQuickFilters(html, event) {
    const newQuickFilters = html.querySelectorAll('quick-filter-dropdown');
    
    for (const newFilter of newQuickFilters) {
      const filterLabel = newFilter.dataset.filterLabel;
      const existingFilter = document.querySelector(`quick-filter-dropdown[data-filter-label="${filterLabel}"]`);
      
      if (!existingFilter) continue;
      
      const isTriggeredFromThis = event?.target?.closest('quick-filter-dropdown')?.dataset?.filterLabel === filterLabel;
      
      if (isTriggeredFromThis) continue;
      
      if (typeof existingFilter.updateContent === 'function') {
        existingFilter.updateContent(newFilter.innerHTML);
      } else {
        existingFilter.innerHTML = newFilter.innerHTML;
      }
    }
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-filter-count'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
      document.querySelector(selector).classList.remove('loading');
    });

  }

  static syncSortSelects(html) {
    const sortByBar = html.querySelector('#SortByBar');
    const sortByMobile = html.querySelector('#SortByMobile');
    
    if (sortByBar) {
      const currentSortByBar = document.querySelector('#SortByBar');
      if (currentSortByBar) {
        currentSortByBar.value = sortByBar.value;
      }
    }
    
    if (sortByMobile) {
      const currentSortByMobile = document.querySelector('#SortByMobile');
      if (currentSortByMobile) {
        currentSortByMobile.value = sortByMobile.value;
      }
    }
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({
      searchParams
    }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      }];
  }

  onSubmitHandler(event) {
    event.preventDefault();
    
    const triggeredForm = event.target.closest('form');
    const triggeredFormData = new FormData(triggeredForm);
    
    const desktopFilterForm = document.getElementById('FacetFiltersForm');
    const mobileFilterForm = document.getElementById('FacetFiltersFormMobile');
    
    const searchParams = new URLSearchParams();
    
    const sortBy = triggeredFormData.get('sort_by');
    if (sortBy) {
      searchParams.set('sort_by', sortBy);
    }
    
    if (desktopFilterForm) {
      const desktopFormData = new FormData(desktopFilterForm);
      for (const [key, value] of desktopFormData.entries()) {
        if (key !== 'sort_by') {
          searchParams.append(key, value);
        }
      }
    }
    
    if (mobileFilterForm) {
      const mobileFormData = new FormData(mobileFilterForm);
      for (const [key, value] of mobileFormData.entries()) {
        if (key !== 'sort_by') {
          searchParams.append(key, value);
        }
      }
    }
    
    const barForm = document.querySelector('.facets--bar-right');
    if (barForm && barForm !== triggeredForm) {
      const barFormData = new FormData(barForm);
      for (const [key, value] of barFormData.entries()) {
        if (key !== 'sort_by' && !searchParams.has(key)) {
          searchParams.set(key, value);
        }
      }
    }
    
    if (searchParams.get('filter.v.price.gte') === "0.00") {
      searchParams.delete('filter.v.price.gte');
    }
    if (document.querySelector('.price_slider')) {
      if (searchParams.get('filter.v.price.lte') === parseFloat(document.querySelector('.price_slider').dataset.max).toFixed(2)) {
        searchParams.delete('filter.v.price.lte');
      }
    }
    
    const hasOtherFilters = Array.from(searchParams.keys()).some(key => 
      (key.startsWith('filter.') && key !== 'filter.v.availability') || key === 'sort_by'
    );
    
    if (hasOtherFilters) {
      searchParams.set('filter.v.availability', '1');
    } else {
      searchParams.delete('filter.v.availability');
    }
    
    FacetFiltersForm.renderPage(searchParams.toString(), event);
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }

  onMore(e) {
    let ul = e.target.closest('.thb-filter-content').querySelector('ul');

    if (ul.hasAttribute('filters-open')) {
      e.target.textContent = theme.strings.showMore;
      ul.removeAttribute('filters-open');
    } else {
      e.target.textContent = theme.strings.showLess;
      ul.setAttribute('filters-open', '');
    }
    e.preventDefault();
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('a').forEach((item) => {
      item.addEventListener('click', (event) => {
        event.preventDefault();
        const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
        form.onActiveFilterClick(event);
      });
    });
  }
}

customElements.define('facet-remove', FacetRemove);

class FacetToolbar extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.productGrid = this.closest('#ProductGridContainer');
    this.compareToggle = this.querySelector('#compare_toggle');
    this.layoutSwitcher = this.querySelector('.facets--bar-view-as');
    this.buttons = this.querySelectorAll('.facets--bar-view-as-button');
    this.productLayout = window.localStorage.getItem('product-layout');
    if (this.layoutSwitcher) {
      this.buttons.forEach((button) => {
        button.addEventListener('click', (evt) => {
          [].forEach.call(this.buttons, function (el) {
            el.removeAttribute('disabled');
          });
          this.onLayoutChange(button, button.dataset.value);
          evt.preventDefault();
        });
      });

      if (this.productLayout && this.productLayout === 'list') {
        const toggle = this.querySelector(`.facets--bar-view-as-button-${this.productLayout}`);
        if (toggle) toggle.click();
      }
    }
    if (this.compareToggle) {
      this.compareToggle.addEventListener('change', this.onCompare);
    }
  }
  onLayoutChange(button, value) {
    button.setAttribute('disabled', '');
    this.productGrid.dataset.layout = value;
    window.localStorage.setItem('product-layout', value);
  }
  onCompare(e) {
    document.body.classList.toggle('compare-true');
    e.preventDefault();
  }
}
customElements.define('facet-toolbar', FacetToolbar);

class PriceSlider extends HTMLElement {

  constructor() {
    super();
  }
  connectedCallback() {
    this.slider = this.querySelector('.price_slider');
    this.amounts = this.querySelector('.price_slider_amount');
    this.form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    this.inputEvent = new CustomEvent('input');

    const args = {
      start: [
        parseFloat(this.slider.dataset.minValue || 0),
        parseFloat(this.slider.dataset.maxValue || this.slider.dataset.max)
      ],
      connect: true,
      step: 10,
      direction: document.dir,
      handleAttributes: [
        { 'aria-label': 'lower' },
        { 'aria-label': 'upper' },
      ],
      range: {
        'min': 0,
        'max': parseFloat(this.slider.dataset.max)
      }
    };
    noUiSlider.create(this.slider, args);

    this.slider.noUiSlider.on('update', this.onSliderUpdate.bind(this));
    this.slider.noUiSlider.on('change', this.onSliderChange.bind(this));

  }
  onSliderUpdate(values) {
    this.amounts.querySelector('.field__input_min').value = values[0];
    this.amounts.querySelector('.field__input_max').value = values[1];
  }

  onSliderChange(values) {
    this.form.querySelector('form').dispatchEvent(this.inputEvent);
  }
}
customElements.define('price-slider', PriceSlider);

class QuickFilterDropdown extends HTMLElement {
  constructor() {
    super();
    this.filterLabel = this.dataset.filterLabel;
  }

  connectedCallback() {
    this.button = this.querySelector('.quick-filter-btn');
    this.content = this.querySelector('.quick-filter-content');
    this.parentContainer = this.closest('.facets--bar-inner');
    this.scrollHandler = null;

    if (!this.button || !this.content) return;

    this.button.addEventListener('click', (e) => {
      e.stopPropagation();
      this.#toggle();
    });

    this.#setupCheckboxListeners();
    this.#setupOutsideClickListener();
  }

  #toggle() {
    const isOpen = this.hasAttribute('open');
    const isMobile = window.innerWidth <= 767;
    
    document.querySelectorAll('quick-filter-dropdown[open]').forEach(dropdown => {
      if (dropdown !== this) {
        dropdown.removeAttribute('open');
      }
    });

    if (isOpen) {
      this.removeAttribute('open');
      if (this.parentContainer && isMobile) {
        this.parentContainer.classList.remove('has-open-dropdown');
      }
      this.#resetPosition();
      this.#removeScrollListener();
    } else {
      this.setAttribute('open', '');
      if (this.parentContainer && isMobile) {
        this.parentContainer.classList.add('has-open-dropdown');
      }
      this.#setPosition();
      this.#addScrollListener();
    }
  }

  #setPosition() {
    if (!this.content || !this.button) return;
    
    if (window.innerWidth <= 767) {
      const rect = this.button.getBoundingClientRect();
      this.content.style.position = 'fixed';
      this.content.style.top = `${rect.bottom + 4}px`;
      this.content.style.right = `${window.innerWidth - rect.right}px`;
      this.content.style.left = '';
      this.content.style.width = `${Math.max(220, rect.width)}px`;
    } else {
      this.content.style.position = '';
      this.content.style.top = '';
      this.content.style.left = '';
      this.content.style.right = '';
      this.content.style.width = '';
    }
  }

  #resetPosition() {
    if (!this.content) return;
    this.content.style.position = '';
    this.content.style.top = '';
    this.content.style.left = '';
    this.content.style.right = '';
    this.content.style.width = '';
  }

  #close() {
    this.removeAttribute('open');
    if (this.parentContainer && window.innerWidth <= 767) {
      this.parentContainer.classList.remove('has-open-dropdown');
    }
    this.#resetPosition();
    this.#removeScrollListener();
  }

  #addScrollListener() {
    if (!this.parentContainer || this.scrollHandler) return;
    
    this.scrollHandler = () => {
      if (this.hasAttribute('open')) {
        this.#close();
      }
    };
    
    this.parentContainer.addEventListener('scroll', this.scrollHandler, { passive: true });
    
    if (window.innerWidth > 767) {
      window.addEventListener('scroll', this.scrollHandler, { passive: true });
    }
  }

  #removeScrollListener() {
    if (!this.scrollHandler) return;
    
    if (this.parentContainer) {
      this.parentContainer.removeEventListener('scroll', this.scrollHandler);
    }
    
    if (window.innerWidth > 767) {
      window.removeEventListener('scroll', this.scrollHandler);
    }
    
    this.scrollHandler = null;
  }

  #setupCheckboxListeners() {
    const checkboxes = this.querySelectorAll('input[type="checkbox"]');

    for (const checkbox of checkboxes) {
      checkbox.addEventListener('change', (e) => {
        this.#syncWithMobile(e.target);
        this.#triggerFilter();
      });
    }
  }

  #setupOutsideClickListener() {
    document.addEventListener('click', (e) => {
      if (!this.contains(e.target) && this.hasAttribute('open')) {
        this.#close();
      }
    });

    window.addEventListener('scroll', () => {
      if (this.hasAttribute('open')) {
        this.#close();
      }
    }, { passive: true });
    
    if (this.parentContainer) {
      this.parentContainer.addEventListener('scroll', () => {
        if (this.hasAttribute('open') && window.innerWidth > 767) {
          this.#close();
        }
      }, { passive: true });
    }

    window.addEventListener('resize', () => {
      if (this.hasAttribute('open')) {
        const isMobile = window.innerWidth <= 767;
        if (isMobile) {
          if (this.parentContainer) {
            this.parentContainer.classList.add('has-open-dropdown');
          }
          this.#addScrollListener();
        } else {
          if (this.parentContainer) {
            this.parentContainer.classList.remove('has-open-dropdown');
          }
          this.#removeScrollListener();
        }
        this.#setPosition();
      }
    }, { passive: true });
  }

  #syncWithMobile(checkbox) {
    const mobileForm = document.getElementById('FacetFiltersFormMobile');
    if (!mobileForm) return;

    const mobileCheckbox = mobileForm.querySelector(
      `input[type="checkbox"][name="${checkbox.name}"][value="${checkbox.value}"]`
    );

    if (mobileCheckbox) {
      mobileCheckbox.checked = checkbox.checked;
    }
  }

  #triggerFilter() {
    const mobileForm = document.getElementById('FacetFiltersFormMobile');
    if (mobileForm) {
      mobileForm.dispatchEvent(new Event('input', { bubbles: true }));
    }
  }

  updateContent(newContent) {
    const wasOpen = this.hasAttribute('open');
    const isMobile = window.innerWidth <= 767;
    this.parentContainer = this.closest('.facets--bar-inner');
    this.innerHTML = newContent;
    
    this.button = this.querySelector('.quick-filter-btn');
    this.content = this.querySelector('.quick-filter-content');
    
    if (this.button) {
      this.button.addEventListener('click', (e) => {
        e.stopPropagation();
        this.#toggle();
      });
    }
    
    this.#setupCheckboxListeners();
    
    if (wasOpen) {
      this.setAttribute('open', '');
      if (this.parentContainer && isMobile) {
        this.parentContainer.classList.add('has-open-dropdown');
      }
      this.#setPosition();
      if (isMobile) {
        this.#addScrollListener();
      }
    }
  }
}
customElements.define('quick-filter-dropdown', QuickFilterDropdown);